export default "__VITE_ASSET__34nek6gt__"